module.exports = __webpack_public_path__ + "img/syscw.4716bab5.png";